// extracted by mini-css-extract-plugin
module.exports = {"cookie_settings":"CookieSettings_cookie_settings__xlV0z"};